import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AnimationOnScroll } from "vendors/react-animation-on-scroll";
import styles from "./styles.module.css";
function TextCard(props) {
    return (_jsxs(AnimationOnScroll, { animateIn: `animate__fadeIn${props.from}`, animateOnce: true, offset: 800, className: `${styles.container}`, delay: props.delay || 0, children: [props.icon && (_jsx("div", { className: styles.icon, children: _jsx("img", { src: props.icon, alt: "product icon" }) })), _jsx("div", { className: styles.title, children: props.title }), _jsx("div", { className: styles.text, children: props.desc })] }));
}
export default TextCard;
